import request from '@/plugins/request';
export function AccountLogin(data) {
  // return request({
  //     url: '/api/login',
  //     method: 'post',
  //     data
  // });
  return request({
    url: '/uaa/oauth/token',
    method: 'post',
    data: data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}
export function AccountRegister(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data: data
  });
}
export function getCurrentUser() {
  return request({
    url: '/bms/sys/user/userinfo',
    method: 'get'
  });
}